import React from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';
import { ByLeanloop, HeaderCap } from '@agilytics/components';
import agilyticsLogo from './agilytics-logo.svg';

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacingDouble};
  background: ${({
    theme: {
      colors: { accent },
    },
  }) => accent};
`;

const ChildContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  alignt-content: center;
  flex: 1;
  & > * {
    margin-right: ${({ theme }) => theme.spacingDouble};
  }
`;

const StyledHeaderCap = styled.svg`
  margin-top: -18px;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacingTriple};
`;

const StyledImg = styled.img`
  max-height: ${({ theme }) => theme.fontSizes.heading1};
  margin-right: ${({ theme }) => theme.spacingTriple};
`;

export default function Header(props) {
  return (
    <>
      <StyledHeader>
        <Link to="/">
          <StyledImg src={agilyticsLogo} alt="Agilytics Logo" />
        </Link>
        <ChildContainer>{props.children}</ChildContainer>
        <ByLeanloop />
      </StyledHeader>
      <StyledHeaderCap preserveAspectRatio="none" width="1024px" height="50px" viewBox="0 0 1024 105">
        <HeaderCap />
      </StyledHeaderCap>
    </>
  );
}
